import { inject, Injectable } from '@angular/core';
import { GgAiTroubleshootAdapter } from './gg-ai-troubleshoot.adapter';
import { Observable, throwError } from 'rxjs';
import {
  InterceptorUtil,
  LoggerService,
  normalizeHttpError,
  OccEndpointsService,
  USE_CLIENT_TOKEN,
} from '@spartacus/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { GGFaqsAI, GGSapIdWSDTO } from '../../components/gg-ai-troubleshoot/gg-ai-troubleshoot.component';

@Injectable({
  providedIn: 'root',
})
export class OccGgAiTroubleshootAdapter implements GgAiTroubleshootAdapter {
  protected logger = inject(LoggerService);

  constructor(
    private http: HttpClient,
    private occEndpoints: OccEndpointsService
  ) {}

  getSapIdFromAuidOrSn(auidOrSn: string): Observable<GGSapIdWSDTO> {
    const url = this.occEndpoints.buildUrl('aiTroubleshootCheckAppliance', {
      urlParams: { auidOrSn },
    });

    let headers = new HttpHeaders();
    headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);

    return this.http
      .get<GGSapIdWSDTO>(url, { headers })
      .pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }

  getFaqsAI(auidOrSn: string, issueDescription: string): Observable<GGFaqsAI> {
    const url = this.occEndpoints.buildUrl('aiTroubleshootIssueDescription', {
      urlParams: {
        auidOrSn,
      },
    });

    let headers = new HttpHeaders()
      .set('Accept', 'application/json; charset=utf-8')
      .set('Content-Type', 'application/json; charset=utf-8');
    headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);

    const body = { issueDescription };

    return this.http
      .post<GGFaqsAI>(url, body, { headers })
      .pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }
}
